import { render, staticRenderFns } from "./event-manage.vue?vue&type=template&id=60512baa"
import script from "./event-manage.vue?vue&type=script&lang=js"
export * from "./event-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60512baa')) {
      api.createRecord('60512baa', component.options)
    } else {
      api.reload('60512baa', component.options)
    }
    module.hot.accept("./event-manage.vue?vue&type=template&id=60512baa", function () {
      api.rerender('60512baa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/physical-model/event-manage.vue"
export default component.exports